export const badgeScale = 0.3;
